import { SET_CARD_VALIDATION_ERROR } from './action-creators';

const cardContextInitialState = () => {
  return {
    cardValidationError: false,
  };
};

const cardContextReducer = (state, action) => {
  switch (action.type) {
    case SET_CARD_VALIDATION_ERROR: {
      return {
        ...state,
        cardValidationError: action.payload,
      };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

export { cardContextReducer, cardContextInitialState };
